module.exports = __webpack_public_path__ + "img/advance-1-2.svg";